import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <div>
        <br />
        <footer
          className="page-footer font-small"
          style={{
            backgroundColor: "#4B4A4A",
            color: "rgba(255, 255, 255, 0.6)",
            position: "fixed", // <-- changed from "absolute" to "fixed"
            bottom: 0,
            width: "100%",
            left: 0,
            height: "60px",
            zIndex: 100,
          }}
        >
          <div className="footer-copyright text-center py-3">
            © 2025 Copyright{" "}
            <a
              href="https://rhodiumdigitaltechnologies.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "rgba(255, 255, 255, 0.6)" }}
            >
              Rhodium Digital Technologies
            </a>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;
